import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Typography, Box, Grid } from '@mui/material';

const IosAppPage = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1, p: 2 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 8 }}>
                        <Typography variant="body1">
<section id="ggcme-app">
  <div>
    <h2>📱 GGClive.com is Live on the App Store!</h2>
    <p><strong>Support the creators you love—right from your iPhone.</strong></p>

    <p>
      The GGClive.com iOS app is officially available! Discover channels, subscribe to content, and send tips with a seamless, Apple-approved experience.
      <a href="https://apps.apple.com/app/ggc/id6748268912" target="_blank">Download now on the App Store</a>.
    </p>

    <h3>🔑 Key Features:</h3>
    <ul>
      <li>Browse and follow channels across categories</li>
      <li>Subscribe with Apple’s in-app purchase system</li>
      <li>Send tips securely through Apple on iOS</li>
      <li>Manage your account, favorites, and support—all in one place</li>
      <li>Enjoy a clean, ad-free experience designed for fans and creators</li>
    </ul>

    <h3>🔒 Your privacy matters.</h3>
    <p>
      Our app follows Apple’s App Store policies and respects your data.
      <a href="/privacy-policy">View our Privacy Policy</a> and
      <a href="/terms-of-service">Terms of Service</a> for details.
    </p>

    <h3>🎉 Available Now</h3>
    <p>
      Ready to jump in?
      <a href="https://apps.apple.com/app/ggc/id6748268912" target="_blank">Get the app</a>,
      <a href="/sign-up">create your account</a>, or <a href="/contact">contact us</a> if you have questions.
    </p>
  </div>
</section>
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>

                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default IosAppPage;